// extracted by mini-css-extract-plugin
export default {"dates":"LessonDates_dates__tIrGH","datesItem":"LessonDates_datesItem__ZBAUA"};